
export const CHAT_VIEW_MODAL_ID = 'chatView';

/**
 * The size of the chat.
 */
export const CHAT_SIZE = 375;

/**
 * The audio ID of the audio element for which the {@link playAudio} action is
 * triggered when new chat message is received.
 *
 * @type {string}
 */
export const INCOMING_MSG_SOUND_ID = 'INCOMING_MSG_SOUND';

/**
 * The {@code messageType} of error (system) messages.
 */
export const MESSAGE_TYPE_ERROR = 'error';

/**
 * The {@code messageType} of local messages.
 */
export const MESSAGE_TYPE_LOCAL = 'local';

/**
 * The {@code messageType} of remote messages.
 */
export const MESSAGE_TYPE_REMOTE = 'remote';

/**
 * Maximum number of chat messages kept in the live redux buffer (main + visitor threads combined).
 * Older messages are dropped from the tail once this cap is exceeded.
 *
 * This bounds memory and render cost for high-volume webinars (tens of thousands of participants can
 * produce hundreds of thousands of messages). The live panel only ever shows the most recent slice;
 * older history is fetched on demand from the XMPP archive (MAM) when the user scrolls up, so nothing
 * is permanently lost from the user's perspective.
 */
export const MAX_CHAT_MESSAGES = 500;

export const DESKTOP_SMALL_WIDTH_THRESHOLD = 580;

export const MOBILE_SMALL_WIDTH_THRESHOLD = 680;

/**
 * Lobby message type.
 */
export const LOBBY_CHAT_MESSAGE = 'LOBBY_CHAT_MESSAGE';
export const LOBBY_CHAT_INITIALIZED = 'LOBBY_CHAT_INITIALIZED';

export const CHAT_TABS = {
    POLLS: 'polls-tab',
    CHAT: 'chat-tab'
};

/**
 * Formatter string to display the message timestamp.
 */
export const TIMESTAMP_FORMAT = 'H:mm';

/**
 * The modes of the buttons of the chat and polls tabs.
 */
export const BUTTON_MODES = {
    CONTAINED: 'contained',
    TEXT: 'text'
};

/**
 * Types of File Name.
 */
export const FILE_NAME = [
    'mp4', 'mkv', 'jpg', 'jpeg', 'png', 'mpeg4', 'gif', 'eps', 'tiff', 'tif', 'mov', 'wmv',
    'avi', 'avchd', 'flv', 'f4v', 'swf', 'webm', 'pdf', 'docx', 'doc', 'psd', 'xls', 'svg', 'xls', 'xlsx', 'ppt', 'pptx', 'odp', 'mp3', 'wav', 'm4a'
];

/**
 * The duration (in milliseconds) within which a deleted message can be restored (1 minute).
 */
export const MESSAGE_RESTORE_TIMEOUT = 60 * 1000;

